module.exports = __webpack_public_path__ + "img/xin.6c9a28fa.png";